import { Action } from '@main/datamap-types';
import { ActionButton } from '@main/pc-core-components/src/ActionButton';
import { RequestAction } from '@transcend-io/privacy-types';
import React from 'react';

import { ActionButtonWrapper, PanelWrapper } from './wrappers';

/**
 * DisplayActions Props
 */
export interface DisplayActionsProps {
  /** List of ActionButtons */
  actionButtons: Action[];
  /** Select an action to go to the confirmation page */
  selectAction: (action: RequestAction) => void;
  /** The active actions that should be disabled */
  disabledActions?: RequestAction[];
}

/**
 * Display action choices for take control modal
 */
export function DisplayActions({
  actionButtons,
  disabledActions = [],
  selectAction,
}: DisplayActionsProps): JSX.Element {
  return (
    <PanelWrapper>
      {actionButtons.map((actionButtonProps) => (
        <ActionButtonWrapper key={actionButtonProps.type}>
          <ActionButton
            {...actionButtonProps}
            disabled={disabledActions.includes(actionButtonProps.type)}
            onClick={() => selectAction(actionButtonProps.type)}
          />
        </ActionButtonWrapper>
      ))}
    </PanelWrapper>
  );
}
